export default __webpack_public_path__ + "static/media/vitrages.a2496b09.png";